<template>

  <!-- Page Sidebar Ends-->
  
      <div class="container-fluid front_header">
            <div class=" ">
              <div class="row">
                <div class="col-12">
                 <img class="img-fluid for_logo" src="../../../assets/images/logo/logo.png"
                                    alt="looginpage">
                </div>
              </div>
            </div>
          </div>
          <div class="page-body">
      
          
          
    <!--<div class="container-fluid">-->
    <!--  <div class="page-title">-->
    <!--    <div class="row">-->
    <!--      <div class="col-12">-->
    <!--        <h4>Visitor Profile</h4>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <div class="container-fluid">
      <div class="user-profile social-app-profile">
        <div class="row">
          <!-- user profile first-style start-->
          <!--<div class="col-sm-12 box-col-12">-->
          <!--  <div class="card hovercard text-center">-->
          <!--    <div class="cardheader"></div>-->
          <!--    <div class="user-image">-->
          <!--      <div @click="visitorprofile">-->
          <!--        <div class="avatar"><img alt="" :src="getImageUrl(visitor.photo)"></div>-->
          <!--        <div class="icon-wrapper"> <i class="icofont icofont-pencil-alt-5"></i></div>-->
          <!--      </div>-->
          <!--      <div class="user-designation"></div>-->
          <!--      <h4 class="title"> {{visitor.name}} </h4>-->
          <!--      <div class="desc mt-2 text-danger">{{visitor.firmname}}</div>-->
          <!--    </div>-->
          <!--    <div class="info market-tabs ">-->
              <!--  <ul class="nav nav-tabs border-tab tabs-scoial" id="top-tab" role="tablist">-->
              <!--    <li class="nav-item"><a class="nav-link active" id="top-timeline" data-bs-toggle="tab"-->
              <!--        href="#timeline" role="tab" aria-controls="timeline" aria-selected="true">Active</a></li>-->
              <!--    <li class="nav-item"><a class="nav-link" id="top-photos" data-bs-toggle="tab" href="#photos"-->
              <!--        role="tab" aria-controls="photos" aria-selected="false">Past</a></li>-->

              <!--    <li class="nav-item"><a class="nav-link" id="top-about" data-bs-toggle="tab" href="#about" role="tab"-->
              <!--        aria-controls="about" aria-selected="false">About</a></li>-->
              <!--  </ul>-->
          <!--    </div>-->
          <!--  </div>-->
          <!--</div>-->
          
           <div class="col-sm-12 ">
            
            <div class="card   ">
             <div class="   row">
              <div class="col-xl-2 col-4 visitorprofile">
                <div @click="visitorprofile">
                  <div><img  class="prof_avatar" alt="" :src="getImageUrl(wp_path + visitor.photo)"></div>
                  <div class="icon-wrapper"> <i class="icofont icofont-pencil-alt-5"></i></div>
                </div>
              
              </div>
              <div class="col-xl-10 col-8 p-2">
               <router-link to="/ProfilePage" class="text-decoration-none text-dark">
                   <div class="user-designation"></div>
                    <h4 class="title"> {{visitor.name}} </h4>
                    <div class="desc mt-1 text-danger">{{visitor.firmname}}</div>
                    <div class="desc text-dark"><i class="icofont icofont-phone"></i> {{visitor.contact}}</div>
              <!--  <ul class="nav nav-tabs border-tab tabs-scoial" id="top-tab" role="tablist">-->
              <!--    <li class="nav-item"><a class="nav-link active" id="top-timeline" data-bs-toggle="tab"-->
              <!--        href="#timeline" role="tab" aria-controls="timeline" aria-selected="true">Active</a></li>-->
              <!--    <li class="nav-item"><a class="nav-link" id="top-photos" data-bs-toggle="tab" href="#photos"-->
              <!--        role="tab" aria-controls="photos" aria-selected="false">Past</a></li>-->

              <!--    <li class="nav-item"><a class="nav-link" id="top-about" data-bs-toggle="tab" href="#about" role="tab"-->
              <!--        aria-controls="about" aria-selected="false">About</a></li>-->
              <!--  </ul>-->
          </router-link>
              </div>
            </div>
          </div>
              </div>
        </div>
        <div class="tab-content" id="top-tabContent">
          <div class="tab-pane fade show active" id="timeline" role="tabpanel" aria-labelledby="timeline">
            <div class="row mb-5">

              <div class="col-xl-12 col-lg-12 col-md-12  ">
                <div class="row">
                  <div class="col-sm-12" v-for="(item ,index)  in visits" :key="item.id">
                    <div class="card" v-if="item?.workpermit">
                         <div class="card-body">
                        <div class="new-users-social mb-0 ">
                          <div class="d-flex ">
                            <div class="flex-grow-1">
                              <!--<h6 class="mb-0 f-w-700">{{item.name}} </h6>-->
                              <p> Validity :<br> <b>{{item.schedule_date}} </b></p>
                            </div>
                             <span v-if="!isPassActive(item.todate)"  class="badge badge-pill badge-danger text-white">
                                                                Expired
                                                            </span> 
                                                              <span v-else-if="isCheckoutGreater(item.check_in,item.check_out)"  class="badge badge-pill badge-success text-white">
                                                                Checked Out
                                                            </span> 
                                                            <span v-else  class="badge badge-pill badge-success text-white">
                                                               Active
                                                            </span>
                                                             
                          </div>
                        </div>
                        <div class="timeline-content">
                          <span> Purpose : <b>{{item.purpose}}</b></span>
                          <br>
                          <div> Respective Staff : <b>{{item.whom_name}}</b></div>
                           
                          <div class="social-chat">

                            <div class="your-msg" v-if="item.check_in">
                              <div class="d-flex">
                                <i class="fa fa-entry"></i>
                                <div class="flex-grow-1"> Check In @ {{item.check_in}} </div>
                              </div>
                            </div>

                            <div class="your-msg" v-if="item.check_out &&  isCheckoutGreater(item.check_in,item.check_out)">
                              <div class="d-flex">
                                <i class="fa fa-entry"></i>
                                <div class="flex-grow-1"> Check Out @ {{item.check_out}} </div>
                              </div>
                            </div>



                          </div>

                        </div>
                      </div>
                       <div class="card-footer option_buttons" v-if="item.approval_status==1 ">
                        
                        <span type="button" @click="getQrCode(item.token,true)"
                          class="badge btn-success p-1 col-md-4 col-3">QR </span>
                         
                       
                      </div>
                    </div>
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    
                    <div class="card" v-else>
                      <div class="card-body">
                        <div class="new-users-social mb-0 ">
                          <div class="d-flex ">
                            <div class="flex-grow-1">
                              <!--<h6 class="mb-0 f-w-700">{{item.name}} </h6>-->
                              <p> Schedule Date : <b>{{item.schedule_date}} </b></p>
                            </div>
                            <span class="pull-right mt-0"> <i data-feather="more-vertical"></i></span>
                            <span v-if="item.check_out!=null" class="badge badge-pill badge-success text-white">
                              Checked Out
                            </span>
                            <span v-else-if="item.checkout_approval==1"
                              class="badge badge-pill badge-warning text-white">
                              Check Out Approved
                            </span>
                            <span v-else-if="item.check_in!=null" class="badge badge-pill badge-info text-white">
                              Checked In
                            </span>
                            <span v-else-if="item.checkout_approval==2"
                              class="badge badge-pill badge-warning text-white">
                              Check Out Denied
                            </span>
                            <span v-else-if="item.approval_status==0" class="badge badge-pill badge-warning text-white">
                              Pending
                            </span>
                            <span v-else-if="item.approval_status==1" class="badge badge-pill badge-success text-white">
                              Accepted
                            </span>
                            <span v-else-if="item.approval_status==2" class="badge badge-pill badge-danger text-white">
                              Denied
                            </span>
                          </div>
                        </div>
                        <div class="timeline-content">
                          <span> Purpose : <b>{{item.purpose}}</b></span>
                          <br>
                          <div> Staff To Meet : <b>{{item.whom_name}}</b></div>
                          <div v-if="item.meeting_room" class="badge rounded-pill badge-Info ">Meeting Schedule : {{
                            item.meeting_room
                            }}</div>
                          <div v-if="item.approval_status==0">
                            <span type="button" class="badge bg-success p-1" @click="editgatepass(item.id)"><i
                                class="icofont icofont-edit"></i> Edit</span>
                          </div>
                          <div class="social-chat">

                            <div class="your-msg" v-if="item.check_in">
                              <div class="d-flex">
                                <i class="fa fa-entry"></i>
                                <div class="flex-grow-1"> Check In @ {{item.check_in}} </div>
                              </div>
                            </div>

                            <div class="your-msg" v-if="item.check_out">
                              <div class="d-flex">
                                <i class="fa fa-entry"></i>
                                <div class="flex-grow-1"> Check Out @ {{item.check_out}} </div>
                              </div>
                            </div>



                          </div>

                        </div>
                      </div>
                      <div class="card-footer option_buttons" v-if="item.approval_status==1 && !item.check_out">
                        <span type="button" @click="addAccessories_modal(item)"
                          class="badge btn-primary p-1  col-md-4 col-3 ">Accessories</span>
                         
                        <span type="button" @click="getQrCode(item.token)"
                          class="badge btn-success p-1 col-md-4 col-3">QR </span>
                         
                        <span type="button"
                          v-if="item.check_in!=null && item.check_out==null && item.checkout_approval==0"
                          @click="checkOutRequest(item.token)" class="badge btn-danger  p-1  col-md-4 col-5">Request
                          Checkout </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>



          <!--<div class="tab-pane fade" id="about" role="tabpanel" aria-labelledby="about">-->
          <!--  <div class="row">-->
          <!--    <div class="col-xl-12 xl-40 col-lg-12 col-md-5 box-col-4">-->
          <!--      <div class="default-according style-1 faq-accordion" id="accordionExample">-->
          <!--        <div class="card">-->
          <!--          <div class="card-header" id="headingOne">-->
          <!--            <h2 class="mb-0">-->
          <!--              <button class="btn btn-link btn-block text-start f-w-600" type="button"-->
          <!--                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"-->
          <!--                aria-controls="collapseOne">My Profile</button>-->
          <!--            </h2>-->
          <!--          </div>-->
          <!--          <div class="collapse show" id="collapseOne" aria-labelledby="headingOne"-->
          <!--            data-bs-parent="#accordionExample">-->
          <!--            <div class="card-body socialprofile filter-cards-view">-->
          <!--              <div class="d-flex"><img class="img-50 img-fluid m-r-20 rounded-circle"-->
          <!--                  src="../../../assets/images/user/1.jpg" alt="">-->
          <!--                <div class="flex-grow-1">-->
          <!--                  <h6 class="font-primary f-w-600">About You</h6>-->
          <!--                  <span class="d-block"><span><i class="fa fa-phone"> </i><span-->
          <!--                        class="px-2">{{visitor.contact}}</span></span></span>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="likes-profile text-center">-->
          <!--                <h5> <span> <i class="fa fa-heart font-danger"></i> {{visits.length}}</span></h5>-->
          <!--              </div>-->
          <!--              <div class="text-center">Times You Visited HD Hyundai</div>-->
          <!--              <button class="btn btn-danger" @click="logout">Logout</button>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->

          <!--      </div>-->
          <!--    </div>-->

          <!--  </div>-->
          <!--</div>-->
          <!--<div class="tab-pane fade" id="photos" role="tabpanel" aria-labelledby="photos">-->
          <!--  <div class="row">-->
          <!--    <div class="col-sm-12" v-for="(item ,index)  in past_visits" :key="item.id">-->
          <!--      <div class="card">-->
          <!--        <div class="card-body">-->
          <!--          <div class="new-users-social mb-0 ">-->
          <!--            <div class="d-flex ">-->
          <!--              <div class="flex-grow-1">-->
          <!--                <h6 class="mb-0 f-w-700">{{item.name}} </h6>-->
          <!--                <p> Schedule Date : <b>{{item.schedule_date}} </b></p>-->
          <!--              </div>-->
          <!--              <span class="pull-right mt-0"> <i data-feather="more-vertical"></i></span>-->
          <!--              <span v-if="item.checkout_approval==1" class="badge badge-pill badge-warning text-white">-->
          <!--                Check Out Approved-->
          <!--              </span>-->
          <!--              <span v-else-if="item.check_out!=null" class="badge badge-pill badge-success text-white">-->
          <!--                Checked Out-->
          <!--              </span>-->
          <!--              <span v-else-if="item.check_in!=null" class="badge badge-pill badge-info text-white">-->
          <!--                Checked In-->
          <!--              </span>-->
          <!--              <span v-else-if="item.checkout_approval==2" class="badge badge-pill badge-warning text-white">-->
          <!--                Check Out Denied-->
          <!--              </span>-->
          <!--              <span v-else-if="item.approval_status==0" class="badge badge-pill badge-warning text-white">-->
          <!--                Pending-->
          <!--              </span>-->
          <!--              <span v-else-if="item.approval_status==1" class="badge badge-pill badge-success text-white">-->
          <!--                Accepted-->
          <!--              </span>-->
          <!--              <span v-else-if="item.approval_status==2" class="badge badge-pill badge-danger text-white">-->
          <!--                Denied-->
          <!--              </span>-->


          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="timeline-content">-->
          <!--            <span> Purpose : <b>{{item.purpose}}</b></span>-->
          <!--            <br>-->
          <!--            <div v-if="item.meeting_room" class="badge rounded-pill badge-Info ">Meeting Schedule : {{-->
          <!--              item.meeting_room-->
          <!--              }}</div>-->
          <!--            <div class="social-chat">-->

          <!--              <div class="your-msg" v-if="item.check_in">-->
          <!--                <div class="d-flex">-->
          <!--                  <i class="fa fa-entry"></i>-->
          <!--                  <div class="flex-grow-1 checkin"> Check In @ {{item.check_in}} </div>-->
          <!--                </div>-->
          <!--              </div>-->

          <!--              <div class="your-msg" v-if="item.check_out">-->
          <!--                <div class="d-flex">-->
          <!--                  <i class="fa fa-entry"></i>-->
          <!--                  <div class="flex-grow-1 checkout"> Check Out @ {{item.check_out}} </div>-->
          <!--                </div>-->
          <!--              </div>-->


          <!--            </div>-->

          <!--          </div>-->
          <!--        </div>-->

          <!--      </div>-->
          <!--    </div>-->
          <!--  </div>-->
          <!--</div>-->
        </div>
      </div>
    </div>




    <div class="modal fade" id="qrcodeView" tabindex="-1" role="dialog" aria-labelledby="qrcodeView" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">QR Code</h4>
            <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="modal-toggle-wrapper ">
              <div class="col-sm-12 text-center">
                <canvas ref="qrcodeCanvas"></canvas>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="col-12">
              <!--<button class="btn btn-primary" @click="download_pass">Download</button>-->
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="modal fade" id="accessoriesModal" tabindex="-1" role="dialog" aria-labelledby="accessoriesModal"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Mention Carrying Accessories</h4>
            <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="modal-toggle-wrapper ">
              <div class="col-sm-12">
                <div class="input-group">
                  <input class="form-control" type="text" placeholder="Type Accessories Here"
                    aria-label="Type Accessories Here" v-model="accessories_name">
                  <button class="btn btn-outline-warning" @click="add_accessories" type="button">Add</button>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <ul class="list-group list-group-flush">
                    <li v-for="(item ,index)  in accessories" :key="item.id">{{ item.name }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">

          </div>
        </div>
      </div>
    </div>

  </div>


  <div class="fixed-bottom bg-light border-top shadow-sm">
    <div class="d-flex justify-content-around text-center py-2">
      <router-link to="/visitorpage" class="text-decoration-none text-dark">
        <div><i class="fa fa-home fa-lg"></i></div>
        <small>Home</small>
      </router-link>
      <router-link to="/ActivePage" class="text-decoration-none text-dark">
        <div><i class="fa fa-bolt fa-lg"></i></div>
        <small>Active</small>
      </router-link>
      <router-link to="/PastPage" class="text-decoration-none text-dark">
        <div><i class="fa fa-history fa-lg"></i></div>
        <small>Past</small>
      </router-link>
      <router-link to="/ProfilePage" class="text-decoration-none text-dark">
        <div><i class="fa fa-user fa-lg"></i></div>
        <small>Profile</small>
      </router-link>
      <a @click="creategatepass" class="text-decoration-none text-dark">
        <div><i class="fa fa-plus-circle fa-lg"></i></div>
        <small>Create</small>
      </a>
    </div>
  </div>

  <span @click="creategatepass" type="button" class="btn  btn-pill btn-secondary createbtn">Create Gatepass</span>


</template>
<style scoped>
.prof_avatar{
    height: 250px;
}
.option_buttons{
        display: flex;
        gap: 5px;
    
}
.option_buttons button{
    padding: 2px 5px;
}
 
.social-chat .flex-grow-1{
        padding: 2px;
}
.social-chat .flex-grow-1:before{
        top: 5px;
}
  .createbtn {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 999;
  }

  .page-body {
    margin-left: 0 !important;
    margin-top: 0px !important;
  }

  .user-profile .hovercard .cardheader {
    height: 70px;
    background: linear-gradient(45deg, #0437c8, #007611);
  }

  @media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
      position: sticky;
    }

    .user-profile .hovercard .info {
      padding: 10px;
    }

    .tabs-scoial {
      padding-top: 60px;
    }
  }

  .checkin {
    background: #d4ffb4;
  }

  .checkout {
    background: #dbd7ff;
  }
  .market-tabs .nav .nav-item .nav-link{
      padding-top: 0px;
      margin-top: 30px;
  }
  
  .prof_avatar{
      /*border-radius: 90px;*/
    /*height: 125px;*/
    /*width: 125px;*/
    height: 130px;
    width: -webkit-fill-available;
  }
  .visitorprofile .icon-wrapper{
      position: absolute;
        right: 17px;
        bottom: 10px;
        background: white;
        padding: 3px;
        border-radius: 10px;
  }
</style>

<script>
  // @ is an alias to /src 
  import PageTitle from '@/components/PageTitle.vue';
//   import axios from 'axios';
import axios from "@/plugins/axios";
  import QRCode from 'qrcode';
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    responseType: 'json'
  };
  export default {
    name: 'VisitorPage',
    components: {
      PageTitle
    },
    mounted() {
      if (this.$route.query.q) {
        this.getBasicsWithToken(this.$route.query.q);
      } else if (localStorage['token']) {
        this.getBasics(localStorage['token'], 1);
      } else {
        this.$router.push({ name: "register" });
      }



    //   document.addEventListener("DOMContentLoaded", function () {
    //     const navLinks = document.querySelectorAll('.nav-tabs .nav-link');

    //     navLinks.forEach(link => {
    //       link.addEventListener('click', function () {
    //         navLinks.forEach(l => l.classList.remove('custom-active')); // remove from all
    //         this.classList.add('custom-active'); // add to clicked one
    //       });
    //     });

    //     // set the initially active one
    //     document.querySelector('.nav-tabs .nav-link.active').classList.add('custom-active');
    //   });






    },
    data() {
      return {
        visitor: { "name": '', "firmname": '', "contact": '', "purpose": '' },
        visits: [],
        accessories: [],
        addAccessories_passid: '',
        accessories_name: '',
        past_visits: [],
        isLiveStarted:false,
        intervalId:0,
        wp_path:''
      }
    },
    beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      console.log('Interval cleared');
    }
  },
    methods: {
      //visitorcreategatepass

      creategatepass() {
        //   window.location.assign(window.location.origin + "/visitorcreategatepass");

        if (this.visitor.photo && !this.visitor.photo.includes('.bin'))
          this.$router.push({ name: "visitorcreategatepass" });
        else
          this.$router.push({ name: "capture" });
      },
      capture_img() {
        //   window.location.assign(window.location.origin + "/capture");
        this.$router.push({ name: "capture" });
      },
      visitorprofile() {
        this.$router.push({ name: "capture" });
      },
      updateData(value) {
        this.gatepass = value;
      },
      getBasics(token, isLocalToke = 0) {
        var self = this;
        axios.post('getVisitorProfile').then(function (response) {
            if(response.data.expired){
                
                localStorage.removeItem('token');
                localStorage.removeItem('_emp_token');
                 window.location.assign(window.location.origin + "/register");
                
            }
                    
            
            
          if (response.data.is == 1) {
            localStorage.removeItem('_emp_token');
            self.visitor = response.data.user;
            self.wp_path = response.data.wp_path;
            
            if (self.visitor.photo == '' || self.visitor.photo == null){
              self.$router.push({ name: "capture" });
            } else if (self.visitor.name == '' || self.visitor.name == null){
              self.$router.push({ name: "visitorprofile" });
            }else if (self.visitor.aadharcard == '' || self.visitor.aadharcard == null){
              self.$swal("Please Update Adhar Card");
               self.$router.push({ name: "ProfilePage" });
            }
            

            self.visits = response.data.visits;
            self.past_visits = response.data.past_visits;
            window.scrollTo(0, 0);
          } else if (response.data.is == 0) {
            localStorage.removeItem('token');
            self.$router.push({ name: "register" });
          }

            if(!self.isLiveStarted){
                    self.isLiveStarted=true;
                   self.intervalId= setInterval(self.refreshPage, 10000);
                }

        });
      },

     getBasicsWithToken(token) {
        var self = this;
        axios.post('getBasicsWithToken',{token:token}).then(function (response) {
            if(response.data.expired){
                
                localStorage.removeItem('token');
                localStorage.removeItem('_emp_token');
                
                
                
            }
                    
            
            
          if (response.data.is == 1 && response.data.token) {
              
              //if verified set server token to user
                    localStorage.setItem('token',response.data.token);
                    localStorage.removeItem('_emp_token');
                    self.visitor = response.data.user;
    
                    if (self.visitor.name == '')
                      self.$router.push({ name: "visitorprofile" });
                    else{
                         window.location.assign(window.location.origin + "/visitorpage");
                    }
        
                    self.visits = response.data.visits;
                    self.past_visits = response.data.past_visits;
                    window.scrollTo(0, 0);
              } else if (response.data.is == 0) {
                localStorage.removeItem('token');
                self.$router.push({ name: "register" });
              }



        });
      },


      checkOutRequest(token) {
        var self = this;
        axios.post('checkOutRequest', { token: token }).then(function (response) {
            self.$swal(response.data.msg);
        //   if (response.data.is == 1) {
        //     window.scrollTo(0, 0);
        //   }
        });
      },
      add_accessories(token) {
        var self = this;
        axios.post('addGatePasAccessories', {  accessories_passid: this.addAccessories_passid, accessories_name: this.accessories_name }).then(function (response) {
          if (response.data.is == 1) {
            self.accessories = response.data.accessories;
            self.accessories_name="";
            window.scrollTo(0, 0);
          }else
                  self.$swal(response.data.msg);
              
        });
      },
      getImageUrl(image) {
        if (image && !image.includes('.bin'))
          return `${this.$hostname}/writable/uploads/visitors/${image}`;
        else
          return `${this.$hostname}/writable/visitors/user.png`;
      },

      async getQrCode(token,isWp=false) {
        try {
          if (token.length > 0) {
            const canvas = this.$refs.qrcodeCanvas;
            var url = this.$api_host ;//+ 'vp?q=' + token;
            if(isWp)
                url += 'wp?q=' + token;
            else 
                url += 'vp?q=' + token;
            //var url= 'http://192.168.1.8:8081/visitorgatepassview?q='+token;
            await QRCode.toCanvas(canvas, url, { width: 200 });
            $("#qrcodeView").modal("toggle");
          }

        } catch (error) {
          console.error(error);
        }
      },
      addAccessories_modal(visit) {
        this.addAccessories_passid = visit.gatepassid;
        if (this.addAccessories_passid > 0) {
          var self = this;
          axios.post('getAccessories', { token: localStorage['token'], accessories_passid: this.addAccessories_passid, accessories_name: this.accessories_name }).then(function (response) {
            if (response.data.is == 1) {
              self.accessories = response.data.accessories;
              $("#accessoriesModal").modal("toggle");
            }
          });



        }

      },
      logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('_emp_token');
        this.$router.push({ name: "register" });
      },

      editgatepass(id) {

        this.$router.push(`/visitorcreategatepass?id=${id}`);

      },
      //13.05.2025
        refreshPage() {
            var self = this;
            axios.post('refreshVisitorGatepass').then(function (response) {
                if(response.data.visits && response.data.visits.length>0){
                    self.visits = response.data.visits;
                }
            });
        },
        
        todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;
                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;
            },

        isPassActive(todate){
                        const here_todate = new Date(todate.replace(' ', 'T'));
                        const today_Date = new Date(this.todayDate().replace(' ', 'T')); 
                        return here_todate >= today_Date;
        },
 isCheckoutGreater(checkInDate,checkOutDate) {
                    
                    if(checkInDate && !checkOutDate)
                        return false
                    else if(!checkInDate && !checkOutDate)
                        return false
                    else if(checkOutDate){
                        const inDate = new Date(checkInDate.replace(' ', 'T'));
                        const outDate = new Date(checkOutDate.replace(' ', 'T')); 
                        return outDate > inDate;
                    }else
                     return true;
                    
                },


    }
  }





</script>